// extracted by mini-css-extract-plugin
export default {"searchBox":"Home_searchBox__aZ1W5","heroImage":"Home_heroImage__hr+kR"};